import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-28f5a876")

_pushScopeId("data-v-28f5a876")
const _hoisted_1 = { class: "scheme-custom-wrapper" }
const _hoisted_2 = { class: "scheme-custom-box" }
const _hoisted_3 = {
  key: 0,
  class: "scheme-custom-item__title"
}
const _hoisted_4 = { class: "scheme-custom-item__body" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("查看睡眠改善方案")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_col = _resolveComponent("van-col")
  const _component_van_row = _resolveComponent("van-row")
  const _component_van_sticky = _resolveComponent("van-sticky")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          class: "scheme-custom-item",
          key: index
        }, [
          (item.title)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("span", {
                  textContent: _toDisplayString(item.title)
                }, null, 8, ["textContent"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_4, [
            (item.isRichText)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  innerHTML: item.content
                }, null, 8, ["innerHTML"]))
              : (_openBlock(), _createBlock("div", {
                  key: 1,
                  textContent: _toDisplayString(item.content)
                }, null, 8, ["textContent"]))
          ])
        ]))
      }), 128)),
      _createVNode(_component_van_sticky, {
        "offset-bottom": 20,
        position: "bottom",
        "safe-area-inset-bottom": "",
        style: {"margin":"25px 0"}
      }, {
        default: _withId(() => [
          _createVNode(_component_van_row, null, {
            default: _withId(() => [
              _createVNode(_component_van_col, {
                span: "20",
                offset: "2"
              }, {
                default: _withId(() => [
                  _createVNode(_component_van_button, {
                    onClick: _ctx.toHealthPage,
                    type: "primary",
                    color: "rgb(116, 83, 213)",
                    round: true,
                    size: "normal",
                    block: ""
                  }, {
                    default: _withId(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
})